module.exports = __webpack_public_path__ + "img/ch13_10_古镇石桥汉服.0ede69cf.jpg";